export default {
    title: {
        color: "primary.700",
        mb: 0.5
    },
    description: {
        display: "block",
        color: "greyscale.700",
        mb: 0.5
    },
    passwordAdornment: {
        color: "greyscale.600",
        display: "flex",
        alignItems: "center"
    }
};
